import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';
import { AlertsAndNotifications } from 'src/app/services/common/alerts-and-notifications-service.service';
import { AlertsAndNotificationsServiceService } from 'src/app/services/common/alerts-and-notifications-service.service';
import { MessageBoxComponent } from '../../message-box/message-box.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Tooltip } from 'primeng/tooltip';



@Component({
  selector: 'app-an-model-view',
  templateUrl: './an-model-view.component.html',
  styleUrls: ['./an-model-view.component.scss']
})
export class AnModelViewComponent implements OnInit {
    @Input() public Content: any;
 @ViewChild(Tooltip) tooltip1!:Tooltip ;
 @ViewChild(Tooltip) tooltip2!:Tooltip ;
  AlertsAndNotificationsModal: UntypedFormGroup;
  ToCCANPlaceHolders:any[];
  SubBodyANPlaceHolders:any[];
  Targetuserlist:any[];
  SubjectTooltipOutput:any;
  BodyTooltipOutput:any;
  NotificationsTooltipOutput:any;
  AllNotificationEvents:any[];
  ApplicationTypeList:any[];
  NotificationEvents:any[] = [];
  AllNotificationEventsJson:string;
  AlertEvents:any[];
  Heading:string;
  IsNotification: any;
  IsEmail:any;
  AddDisable: boolean = false;
  AlrtNotif: AlertsAndNotifications;
    singlerecord: any;
    tooltipValue : string;
  selectedtoplaceholders: any;
  selectedccplaceholders: any;
  selectedsystemtoplaceholders: any;
  AlreadyConfiguredEvents:any;
  CancelButton:string;
  disableinfo:boolean;
  disableNotifinfo:boolean;
  Ischeck:boolean=false;
  OptionsTooltip: any[] = [];
  OptionsCCTooltip: any[] = [];
  Isconfigured:any;
  action: Subject<any> = new Subject();
  isSubjtooltip : boolean = false
  isBodytooltip:boolean = false;
   content:any;

  editorInit: Record<string, any> | undefined = {
    base_url: '/tinymce',
    selector: 'editor#bodyeditor',
    suffix: '.min',
    statusbar: false,
    height: '200px !important',
    readonly: 1,
    paste_data_images: true,
    menubar: true,
    toolbar: true,
    plugins: [
        'advlist autolink lists link image charmap print preview anchor',
        'searchreplace visualblocks fullscreen',
        'insertdatetime media table paste'
    ]
  };
    MappedApplications: any =[];

  constructor(private fb: UntypedFormBuilder,
    public modalRef: NgbActiveModal,
    private anservice:AlertsAndNotificationsServiceService,
    private modalService: NgbModal,
    private commonService: CommonService,) {
    this.AlertsAndNotificationsModal = this.fb.group({
      ID: [null],
      Name: ["", [Validators.required, Validators.maxLength(100), this.IsEmptySpaces]],
      Active: [true],
      Targetuser: ["", [Validators.required]],
      NotifEvent: ["", [Validators.required]],
      AlertEvent: ["", [Validators.required]],
      DaysNo: [null, [Validators.required, Validators.maxLength(2), Validators.min(1)]],
      Days: [""],
      Email: [false],
      EmailTo: ["", [Validators.required]],
      EmailToPlaceHolders: [null],
      EmailCC: [""],
      EmailCCPlaceHolders: [null],
      EmailSubject: ["", [Validators.required, this.IsEmptySpaces]],
      EmailBody: [""],
      System: [false],
      SystemToPlaceHolders: [null, [Validators.required]],
      ApplicationType: ["", [Validators.required]],
      SystemNotification: ["", [Validators.required, Validators.maxLength(1000), this.IsEmptySpaces]],
      ANTYPE: [""],
      EmailBodyID: [""]
  });
  }

    ngOnInit(): void {
        this.disableinfo = true;
        this.disableNotifinfo = true;
        this.AddDisable = false;;
        this.Heading = this.Content.content.OperationType;
        this.CancelButton = this.Heading == 'View' ? 'Close' : 'Cancel';

        this.getanplaceholders();
        this.Targetuserlist = [
            { value: 'I', label: 'Internal' },
            { value: 'E', label: 'External' },
            { value: 'B', label: 'Both' }
        ];
        this.getanevents();

        if (this.Heading == 'View' || this.Heading == 'Edit') {
            this.getanbyid();
        }
        this.getApplicationtypes();
        if (this.Heading == 'Add') {
            this.disablecontrols();
        }

    }

    selectedValues(event) {
        if (this.AlertsAndNotificationsModal.get("EmailToPlaceHolders").value == null
            && this.AlertsAndNotificationsModal.get("EmailToPlaceHolders").value == undefined) {
            this.OptionsTooltip.push("None");
        } else {
            let placeholder: any
            if (this.OptionsTooltip[0] == "None") {
                this.OptionsTooltip = [];
            }

            if (event.length > 0) {
                this.OptionsTooltip = [];
                this.AlertsAndNotificationsModal.get("EmailToPlaceHolders").value.forEach((element: any) => {
                    placeholder = this.ToCCANPlaceHolders.find(x => element == x.value);
                    let hasValue = this.OptionsTooltip.filter(x => x == placeholder.label);
                    if ((placeholder != null) && hasValue.length == 0) {
                        this.OptionsTooltip.push(placeholder.label);
                    }
                });
            } else {
                this.OptionsTooltip = [];
                this.OptionsTooltip.push("None");
            }
        }
    }

   

  getanplaceholders(){
    this.anservice.getanplaceholders(this.Content.content.ModuleId).subscribe(result =>{
      if (result != null && result != undefined){
        this.ToCCANPlaceHolders = result.filter(function (a) {
          return (a.phtype == 'TO_CC')
        });

        this.SubBodyANPlaceHolders = result.filter(function (a) {
          return (a.phtype == 'OTHERS')
        });

        this.SubjectTooltipOutput = this.SubBodyANPlaceHolders.map(
          (x) => x.label
      ).join("\r\n");
      this.BodyTooltipOutput = this.SubBodyANPlaceHolders.map(
        x=>x.label).join("\r\n");
      this.NotificationsTooltipOutput = this.SubBodyANPlaceHolders.map(
        x=>x.label).join("\r\n");

      }
    },
    err => {

    });
  }

  getanevents(){
    this.anservice.getanevents(this.Content.content.ModuleId).subscribe(result =>{
      if (result != null && result != undefined){

        this.AllNotificationEventsJson = JSON.stringify(result);

        this.NotificationEvents = result.filter(function (a) {
          return (a.AN_TYPE == 'NOTIFICATION')
        });

        this.AlertEvents = result.filter(function (a) {
          return (a.AN_TYPE == 'ALERT')
        });
      }
    },
    err => {

    });
  }
  getApplicationtypes(){
        this.anservice.getApplicationTypes(this.Content.content.ModuleId, this.Content.content.AlertNotificationID).subscribe((result: any) => {
            if (result) {
              this.ApplicationTypeList = result;
              if(this.Heading =="Add")
                this.changeVal("default");
            }
    });

  }

    changeVal(event) {
        let selectedtype;
        if (event == "default") {
            this.MappedApplications = [];
            this.ApplicationTypeList.forEach(element => {
                this.MappedApplications.push(element.value);
            });
            this.AlertsAndNotificationsModal.controls["ApplicationType"].setValue(this.MappedApplications);
            selectedtype = this.AlertsAndNotificationsModal.controls["ApplicationType"].value;
        }
            selectedtype = this.AlertsAndNotificationsModal.controls["ApplicationType"].value;
            if (selectedtype != "" && selectedtype != undefined && selectedtype != null) {
                let TypeLabel = this.ApplicationTypeList.filter((item) => {
                    return selectedtype.indexOf(item.value) > -1;
                })
                let labellist = [];
                TypeLabel.forEach((item) => {
                    labellist.push(item.label);
                });
                this.tooltipValue = labellist.join(",");
            }
            else {
                this.tooltipValue = "";
            }
    }

  IsEmptySpaces(c: UntypedFormControl) {
    if (!c.value || !c.value.trim()) {
        return { valid: false };
    }
    return { valid: true };
  }

  disablecontrols() {
    if(!this.AlertsAndNotificationsModal.controls["Email"].value){
        this.AlertsAndNotificationsModal.get("DaysNo")?.disable();
        this.AlertsAndNotificationsModal.get("Days")?.disable();
        this.AlertsAndNotificationsModal.get("EmailTo")?.disable();
        this.AlertsAndNotificationsModal.get("EmailToPlaceHolders")?.disable();
        this.AlertsAndNotificationsModal.get("EmailCC")?.disable();
        this.AlertsAndNotificationsModal.get("EmailCCPlaceHolders")?.disable();
        this.AlertsAndNotificationsModal.get("EmailSubject")?.disable();
        this.AlertsAndNotificationsModal.get("EmailBody")?.disable();
        this.AlertsAndNotificationsModal.get( "SystemToPlaceHolders")?.disable();
        this.AlertsAndNotificationsModal.get("SystemNotification")?.disable();
    } else{
        setTimeout(() => {
            this.AlertsAndNotificationsModal.controls["EmailBody"]?.enable();
        }, 500);
    }
  }

  targetuserchange(TargetUserValue:string){
    if(this.Content.content.OperationType == 'Add'){
        this.AlertsAndNotificationsModal.controls["NotifEvent"].setValue("");
        let TargetUserlabel = "";
        if(TargetUserValue==""){
            this.AlertsAndNotificationsModal.get("NotifEvent")?.enable();
            this.AlertsAndNotificationsModal.get("AlertEvent")?.enable();
        }
        if(TargetUserValue == 'I'){
            TargetUserlabel = 'Internal'
        }
        if(TargetUserValue == 'E'){
            TargetUserlabel = 'External'
        }
        if(TargetUserValue == 'B'){
            TargetUserlabel = 'Both'
        }
this.AlertsAndNotificationsModal.controls["ANTYPE"].setValue("");
        this.AllNotificationEvents = JSON.parse(this.AllNotificationEventsJson);

        if(TargetUserlabel != 'Both'){
            this.AlreadyConfiguredEvents = this.Content.content.AlreadyConfiguredEvents.filter(x => (x.TargetUser == TargetUserlabel || x.TargetUser=='Both'));

        }
        else{
            this.AlreadyConfiguredEvents = this.Content.content.AlreadyConfiguredEvents.filter(x => (x.TargetUser == 'Internal' || x.TargetUser == 'External') || x.TargetUser == TargetUserlabel);

        }
        this.AlreadyConfiguredEvents.forEach(element => {
            this.AllNotificationEvents = this.AllNotificationEvents.filter(x=>x.NAME != element.ANType);
        });

        this.NotificationEvents = this.AllNotificationEvents.filter(x=>x.AN_TYPE == 'NOTIFICATION' && (x.USER_TYPE == TargetUserValue || x.USER_TYPE == 'B'));
        if(TargetUserValue == 'I'){
            TargetUserlabel = 'Internal'
            if(this.NotificationEvents.length==0){
                this.AlertsAndNotificationsModal.get("NotifEvent")?.disable();
            }
            else{
                this.AlertsAndNotificationsModal.get("NotifEvent")?.enable();
            }
        }
        if(TargetUserValue == 'E'){
            TargetUserlabel = 'External'
            if(this.NotificationEvents.length==0){
                this.AlertsAndNotificationsModal.get("NotifEvent")?.disable();
            }
            else{
                this.AlertsAndNotificationsModal.get("NotifEvent")?.enable();
            }
        }
        if(TargetUserValue == 'B'){
            TargetUserlabel = 'Both'
            if(this.NotificationEvents.length==0){
                this.AlertsAndNotificationsModal.get("NotifEvent")?.disable();
            }
            else{
                this.AlertsAndNotificationsModal.get("NotifEvent")?.enable();
            }
        }
    }
  }

  notificationonchange(NotifiValue: string) {
    if (NotifiValue == "") {
        this.AlertsAndNotificationsModal.get("AlertEvent")?.enable();
        this.AlertsAndNotificationsModal.get("System")?.enable();
        this.AlertsAndNotificationsModal.get("Email")?.enable();
    } else {
        this.AlertsAndNotificationsModal.get("AlertEvent")?.setValue("");
        this.AlertsAndNotificationsModal.get("AlertEvent")?.disable();
        this.AlertsAndNotificationsModal.get("DaysNo")?.disable();
        this.AlertsAndNotificationsModal.controls["ANTYPE"].setValue("NOTIFICATION");
    }

    this.IsNotification = this.NotificationEvents.filter(
        (x) => x.PK_ALERTNOTIF_TYPE_ID == NotifiValue
    );
    if (!this.IsNotification[0].IS_NOTIFICATION) {
        this.AlertsAndNotificationsModal.get("System")?.disable();
        this.AlertsAndNotificationsModal.controls["System"].setValue(false);
        this.disablesystemcontrols();
    } else {
        this.AlertsAndNotificationsModal.get("System")?.enable();
    }
    if (!this.IsNotification[0].IS_EMAIL) {
        this.AlertsAndNotificationsModal.get("Email")?.disable();
        this.AlertsAndNotificationsModal.controls["Email"].setValue(false);
        this.disableemailcontrols();
    } else {
        this.AlertsAndNotificationsModal.get("Email")?.enable();
    }
  }

  alertonchange(AlertValue: string) {
    if (AlertValue == "") {
        if (this.NotificationEvents == null) {
            this.AlertsAndNotificationsModal.get("NotifEvent")?.setValue("");
            this.AlertsAndNotificationsModal.get("NotifEvent")?.disable();
            this.AlertsAndNotificationsModal.get("DaysNo")?.disable();
            this.AlertsAndNotificationsModal.get("System")?.enable();
            this.AlertsAndNotificationsModal.get("Email")?.enable();
        } else {
            this.AlertsAndNotificationsModal.get("NotifEvent")?.enable();
            this.AlertsAndNotificationsModal.controls["DaysNo"].setValue(null);
            this.AlertsAndNotificationsModal.get("DaysNo")?.disable();
        }

        this.AlertsAndNotificationsModal.get("Targetuser")?.setValue("");
        this.AlertsAndNotificationsModal.get("Targetuser")?.enable();

    } else {
        this.AlertsAndNotificationsModal.get("NotifEvent")?.setValue("");
        this.AlertsAndNotificationsModal.get("NotifEvent")?.disable();
        this.AlertsAndNotificationsModal.get("DaysNo")?.enable();
        this.AlertsAndNotificationsModal.get("Targetuser")?.setValue("I");
        this.AlertsAndNotificationsModal.get("Targetuser")?.disable();
        this.AlertsAndNotificationsModal.controls["ANTYPE"].setValue("ALERT");
    }

    this.IsEmail = this.AlertEvents.filter(
        (x) => x.PK_ALERTNOTIF_TYPE_ID == AlertValue
    );
    if (!this.IsEmail[0].IS_NOTIFICATION) {
        this.AlertsAndNotificationsModal.get("System")?.disable();
        this.AlertsAndNotificationsModal.controls["System"].setValue(false);
        this.disablesystemcontrols();
    } else {
        this.AlertsAndNotificationsModal.get("System")?.enable();
    }
    if (!this.IsEmail[0].IS_EMAIL) {
        this.AlertsAndNotificationsModal.get("Email")?.disable();
        this.AlertsAndNotificationsModal.controls["Email"].setValue(false);
        this.disableemailcontrols();
    } else {
        this.AlertsAndNotificationsModal.get("Email")?.enable();
    }
  }

  disablesystemcontrols() {
    this.AlertsAndNotificationsModal.get("SystemToPlaceHolders")?.disable();
    this.AlertsAndNotificationsModal.get("SystemNotification")?.disable();
    this.disableNotifinfo = true;
  }

  disableemailcontrols() {
    this.AlertsAndNotificationsModal.get("EmailTo")?.disable();
    this.AlertsAndNotificationsModal.get("EmailToPlaceHolders")?.disable();
    this.AlertsAndNotificationsModal.get("EmailCC")?.disable();
    this.AlertsAndNotificationsModal.get("EmailCCPlaceHolders")?.disable();
    this.AlertsAndNotificationsModal.get("EmailSubject")?.disable();
    setTimeout(() => {
        this.AlertsAndNotificationsModal.controls["EmailBody"]?.disable();
    }, 400);
    this.disableinfo = true;
    this.Ischeck=true;
  }

  emailonchange(event) {
    if (event) {
        this.enableemailcontrols();
    } else {
        this.disableemailcontrols();
    }
  }

  enableemailcontrols() {
    this.AlertsAndNotificationsModal.get("EmailTo")?.enable();
    this.AlertsAndNotificationsModal.get("EmailToPlaceHolders")?.enable();
    this.AlertsAndNotificationsModal.get("EmailCC")?.enable();
    this.AlertsAndNotificationsModal.get("EmailCCPlaceHolders")?.enable();
    this.AlertsAndNotificationsModal.get("EmailSubject")?.enable();
    this.AlertsAndNotificationsModal.get("EmailBody")?.enable();
    this.Ischeck=false;
    this.disableinfo = false;
  }

  systemonchange(event) {
    if (event) {
        this.enablesystemcontrols();
    } else {
        this.disablesystemcontrols();
    }
  }

  enablesystemcontrols() {
    this.AlertsAndNotificationsModal.get("SystemToPlaceHolders")?.enable();
    this.AlertsAndNotificationsModal.get("SystemNotification")?.enable();
    this.disableNotifinfo = false;
  }

  validateform(): boolean {
    let isValid = true;
    var err: String = '';
    var EmailPattern = new RegExp("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$");
    if (!this.AlertsAndNotificationsModal.valid) {
        if (this.AlertsAndNotificationsModal.get('Name')?.errors?.required || !this.AlertsAndNotificationsModal.get('Name')?.value.trim()) {
            err += ("Please enter Name <br/>");
        }

        // if (this.AlertsAndNotificationsModal.get('Name')?.errors?.maxLength) {
        //     err +=("Length of name should not exceed 100 <br/>");
        // }

        if (this.AlertsAndNotificationsModal.controls['Active'].value) {
            if (!this.AlertsAndNotificationsModal.controls['Email'].value && !this.AlertsAndNotificationsModal.controls['System'].value) {
                err +=("Please select email or system <br/>");
            }
        }

        if (this.AlertsAndNotificationsModal.get('Targetuser')?.enabled) {
          if (this.AlertsAndNotificationsModal.get('Targetuser')?.errors?.required) {
            err +=("Please select Target User <br/>");
          }
      }
      if (this.AlertsAndNotificationsModal.get('ApplicationType')?.enabled) {
        if (this.AlertsAndNotificationsModal.get('ApplicationType')?.errors?.required) {
          err +=("Please select Application Type <br/>");
        }
        else if (this.AlertsAndNotificationsModal.get('ApplicationType')?.value != null && this.AlertsAndNotificationsModal.get('ApplicationType')?.value != "" && this.AlertsAndNotificationsModal.get('ApplicationType')?.value != undefined)
            {
              let selectedIDs = this.AlertsAndNotificationsModal.get('ApplicationType')?.value.join(",")
              let InactiveAvilable = this.ApplicationTypeList.filter((item) => {
                return (selectedIDs.indexOf(item.value) > -1 && item.IsActive == false);
              })[0];
              if (InactiveAvilable != undefined && InactiveAvilable != null) {
                err += "Please remove inactive application type to save the details<br/>";
              }
            }
          }

      if(this.AlertsAndNotificationsModal.controls['ANTYPE'].value){

       if(this.AlertsAndNotificationsModal.controls['ANTYPE'].value=='NOTIFICATION'){
        if (this.AlertsAndNotificationsModal.controls['NotifEvent'].value=="" || this.AlertsAndNotificationsModal.controls['NotifEvent'].value==null || this.AlertsAndNotificationsModal.controls['NotifEvent'].value==undefined) {
         err +=("Please select Notification Event <br/>");
       }
       }
        if (this.AlertsAndNotificationsModal.controls['ANTYPE'].value=='ALERT') {
            if (this.AlertsAndNotificationsModal.controls['AlertEvent'].value=="" || this.AlertsAndNotificationsModal.controls['AlertEvent'].value==null || this.AlertsAndNotificationsModal.controls['AlertEvent'].value==undefined) {
                err +=("Please select Alert Event <br/>");
            }
            if (this.AlertsAndNotificationsModal.get('DaysNo')?.errors?.required) {
                err +=("Please enter # <br/>");
            }
            if (this.AlertsAndNotificationsModal.get('DaysNo')?.errors?.min) {
                err +=("Provide different # of days for the alert <br/>");
            }
            if (this.AlertsAndNotificationsModal.get('DaysNo')?.errors?.maxLength) {
                err +=("Length of # should not exceed 2 <br/>");
            }
        }
    }
    else if(this.AlertsAndNotificationsModal.controls['ANTYPE'].value==""||this.AlertsAndNotificationsModal.controls['ANTYPE'].value==undefined||this.AlertsAndNotificationsModal.controls['ANTYPE'].value==null){
        err +=("Please select Notification Event/Alert Event <br/>");
    }
        if (this.AlertsAndNotificationsModal.controls['Email'].value) {
            var emailto = this.AlertsAndNotificationsModal.controls['EmailTo'].value;
            if (emailto != null) {
                var emailtovalidate = emailto.replaceAll(",", ";");
            }
            if (
                (this.AlertsAndNotificationsModal.get("EmailToPlaceHolders")?.value == null ||
                    this.AlertsAndNotificationsModal.get("EmailToPlaceHolders")?.value.length == 0) &&
                !this.AlertsAndNotificationsModal.get("EmailTo")?.value
            ) {
                err +=("Please enter To <br/>");
            } else if (
                this.AlertsAndNotificationsModal.controls["EmailTo"].value
            ) {
                var emailto =
                    this.AlertsAndNotificationsModal.controls["EmailTo"].value;
                if (emailto != null) {
                    var emailtovalid = emailto.replaceAll(",", ";");
                }
                if (!emailto) {
                    err +=("Please enter To <br/>");
                } else {
                    var emailtoArr = emailtovalid.split(";");
                    for (var i = 0; i < emailtoArr.length; i++) {
                        let isemailvalid = this.commonService.validateEmail(emailtoArr[i].trim());
                        if (!isemailvalid) {
                            err +=("Invalid Email Id in To - " + emailtoArr[i] + " <br/>");
                            break;
                        }
                    }
                }
            }

            var emailCc =
                this.AlertsAndNotificationsModal.controls["EmailCC"].value;
            if (emailCc != null) {
                var emailccvalidate = emailCc.replaceAll(",", ";");
            }
            if (
                this.AlertsAndNotificationsModal.get("EmailCCPlaceHolders")?.value == null &&
                !this.AlertsAndNotificationsModal.get("EmailCC")?.value
            ) {
            } else if (
                this.AlertsAndNotificationsModal.controls["EmailCC"].value
            ) {
                var emailCc =
                    this.AlertsAndNotificationsModal.controls["EmailCC"].value;
                if (emailCc != null) {
                    var emailccvalidate = emailCc.replaceAll(",", ";");
                }
                if (!emailCc) {
                    err +=("Please enter CC <br/>");
                } else {
                    var emailCcArr = emailccvalidate.split(";");
                    for (var i = 0; i < emailCcArr.length; i++) {
                      let isemailvalid = this.commonService.validateEmail(emailCcArr[i].trim());
                        if (!isemailvalid) {

                            err +=("Invalid Email Id in CC - " + emailCcArr[i] + " <br/>");
                            break;
                        }
                    }
                }
            }


            if (
                this.AlertsAndNotificationsModal.get("EmailSubject")?.errors
                    ?.required ||
                !this.AlertsAndNotificationsModal.get(
                    "EmailSubject"
                )?.value.trim()
            ) {
                err +=("Please enter Subject <br/>");
            }
        }

        if (this.AlertsAndNotificationsModal.controls["System"].value) {
            if (
                this.AlertsAndNotificationsModal.get("SystemToPlaceHolders")
                    ?.errors?.required
            ) {
                err +=("Please enter To (Placeholders)<br/>");
            }
            if (
                this.AlertsAndNotificationsModal.get("SystemToPlaceHolders")
                    ?.errors?.maxLength
            ) {
                err +=("Length of To (Placeholders) should not exceed 1000 <br/>");
            }

            if (
                this.AlertsAndNotificationsModal.get("SystemNotification")
                    ?.errors?.required
            ) {
                err +=("Please enter Notification <br/>");
            }
            if (
                this.AlertsAndNotificationsModal.get("SystemNotification")
                    ?.errors?.maxLength
            ) {
                err +=("Length of Notification should not exceed 1000 <br/>");
            }
        }
    } else {
        if (this.AlertsAndNotificationsModal.controls["Email"].value) {
            var emailto =
                this.AlertsAndNotificationsModal.controls["EmailTo"].value;
            if (emailto != null) {
                var emailtovalidate = emailto.replaceAll(",", ";");
            }
            if (
                this.AlertsAndNotificationsModal.get("ToPlaceHolders")?.value ==
                null &&
                !this.AlertsAndNotificationsModal.get("EmailTo")?.value
            ) {
                err +=("Please enter To <br/>");
            } else if (
                this.AlertsAndNotificationsModal.controls["EmailTo"].value
            ) {
                var emailto =
                    this.AlertsAndNotificationsModal.controls["EmailTo"].value;
                if (emailto != null) {
                    var emailtovalid = emailtovalidate.replaceAll(",", ";");
                }
                if (!emailto) {
                    err +=("Please enter To <br/>");
                } else {
                    var emailtoArr = emailtovalidate.split(";");
                    for (var i = 0; i < emailtoArr.length; i++) {
                      let isemailvalid = this.commonService.validateEmail(emailtoArr[i].trim())
                        if (!isemailvalid) {
                            err +=("Invalid Email Id in To - '" + emailtoArr[i] + "' <br/>");
                            break;
                        }
                    }
                }
            }


            if (
                this.AlertsAndNotificationsModal.get("EmailSubject")?.errors
                    ?.required
            ) {
                err +=("Please enter Subject <br/>");
            }
        }

        if (this.AlertsAndNotificationsModal.controls["System"].value) {
            if (
                this.AlertsAndNotificationsModal.get("SystemToPlaceHolders")
                    ?.errors?.required
            ) {
                err +=("Please enter To (Placeholders) <br/>");
            }
            if (
                this.AlertsAndNotificationsModal.get("SystemToPlaceHolders")
                    ?.errors?.maxLength
            ) {
                err +=("Length of To (Placeholders) should not exceed 1000 <br/>");
            }
            if (
                this.AlertsAndNotificationsModal.get("SystemNotification")
                    ?.errors?.required
            ) {
                err +=("Please enter System Notification <br/>");
            }
            if (
                this.AlertsAndNotificationsModal.get("SystemNotification")
                    ?.errors?.maxLength
            ) {
                err +=("Length of System Notification should not exceed 1000 <br/>");
            }
        }
    }

    if (err.length > 0) {
      this.commonService.ValidationBanner(err);
        return (isValid = false);
    } else {
        return isValid;
    }
  }

  save() {
    if (this.validateform()) {
      if ((this.AlertsAndNotificationsModal.dirty || this.AlertsAndNotificationsModal.touched)) {
        let model = this.AlertsAndNotificationsModal.getRawValue();
        model['MappedAppTypesIDs'] = model.ApplicationType.join(",");
        let tempList = this.ApplicationTypeList.filter((item) => {
          return   model['MappedAppTypesIDs'].indexOf(item.value) > -1;
        });
        tempList.forEach((obj, index) => {
          if (index == 0)
            model['MappedAppTypesNames'] = obj.label;
          else
            model['MappedAppTypesNames'] = model['MappedAppTypesNames'] + "," + obj.label;
        });
        this.AlrtNotif = {
            AlertNotificationID: model.ID,
            ModuleId:this.Content.content.ModuleId,
            Name: model.Name.trim(),
            TargetUser:model.Targetuser,
            RecordState: model.Active,
            NotificationEventID: model.NotifEvent,
            AlertEventID: model.AlertEvent,
            EventDays: model.DaysNo,
            IsEmailAlert: model.Email,
            ToAddress: model.EmailTo,
            ToPlaceHolders: model.EmailToPlaceHolders,
            CcAddress: model.EmailCC,
            CcPlaceHolders: model.EmailCCPlaceHolders,
            Subject: model.EmailSubject,
            EmailBodyID: model.EmailBodyID,
            EmailBody: model.EmailBody,
            IsSystemNotification: model.System,
            NotificationToPlaceHolder: model.SystemToPlaceHolders,
            NotificationText: model.SystemNotification,
            ANType: model.ANTYPE,
            OperationType:this.Content.content.OperationType,
            MappedAppTypesNames:model['MappedAppTypesNames'],
            MappedAppTypesIDs: model['MappedAppTypesIDs']

        };

        this.anservice.SaveAlertsAndNotifications(this.AlrtNotif).subscribe(
            result => {
                if (result != null && result != undefined) {
                    if (result.Status) {
                        this.commonService.SuccessBanner(result.errMessage);
                      //  this.action.next();
                        this.modalRef.close();
                    } else {
                        this.commonService.ValidationBanner(result.errMessage);
                    }
                } else {
                    this.commonService.ValidationBanner("Unable to save");

                }
            },
            (err) => {
                this.commonService.ValidationBanner(err);
            }
        );
    } else {
        if(this.Content.content.OperationType === "Edit"){
            this.commonService.ValidationBanner("No changes have been performed");
        //   this.modalService.show(MessageBoxComponent, {
        //     backdrop: false,
        //     keyboard: false,
        //     ignoreBackdropClick: true,
        //     animated: true,
        //     data: {
        //       heading: "Validation Message(s)",
        //       content: { heading: '', description:"No changes have been performed"}
        //     }
        //   });
        }
    }
        // if (this.Content.content.OperationType === "Add") {
        //     //this.createField();
        // }
        // if (this.Content.content.OperationType === "Edit") {
        //     //this.updateField();
        // }
    }
  }

  getanbyid(){
    this.anservice.getanbyid(this.Content.content.ModuleId,this.Content.content.AlertNotificationID).subscribe(result =>{
      if(result != null && result != undefined){
        this.singlerecord = result;
        if (this.singlerecord != null) {
            this.populatedatatocontrols();
            //this.disablecontrols();
        }
      }
    });
  }

  clkSubjToolTip(event){
     
this.isSubjtooltip = !this.isSubjtooltip
    if(this.isSubjtooltip)
    this.tooltip1.activate()
  else{
    this.tooltip1.hide()
  }
  }

  clkBodyToolTip()
  {
     
    this.isBodytooltip = !this.isBodytooltip
    if(this.isBodytooltip)
    {
        this.tooltip2.activate()
    }
    else{
        this.tooltip2.hide()
    }
  }

  populatedatatocontrols() {
        this.AlertsAndNotificationsModal.get("NotifEvent")?.disable();
        this.AlertsAndNotificationsModal.get("AlertEvent")?.disable();
        this.AlertsAndNotificationsModal.get("Targetuser")?.disable();
        if (!this.singlerecord.IsEmailAlert) {
            this.disableemailcontrols();
        }

        if (!this.singlerecord.IsSystemNotification) {
            this.disablesystemcontrols();
        }

        if(!this.singlerecord.IsSystemNotification){
            this.AlertsAndNotificationsModal.get("Email")?.enable();
            this.AlertsAndNotificationsModal.get("System")?.enable();
        }

        // if(this.singlerecord["AlertEventID"]!=null && this.singlerecord["AlertEventID"]!="" && this.singlerecord["AlertEventID"]!=undefined){
        //     this.AlertsAndNotificationsModal.get("Targetuser")?.disable();
        // }

        if(this.singlerecord.MappedApplications.length > 0) {
            this.singlerecord.MappedApplications.forEach(element => {
              this.MappedApplications.push(element.value);
            });
          }
    

        this.AlertsAndNotificationsModal.patchValue({
            ID: this.Content.content.AlertNotificationID,
            Name: this.singlerecord["Name"],
            Active: this.singlerecord["RecordState"],
            Targetuser:this.singlerecord["TargetUser"],
            DaysNo: this.singlerecord["EventDays"],
            Email: this.singlerecord["IsEmailAlert"],
            EmailTo: this.singlerecord["ToAddress"],
            EmailCC: this.singlerecord["CcAddress"],
            EmailSubject: this.singlerecord["Subject"],
            EmailBodyID: this.singlerecord["EmailBodyID"],
            EmailBody: this.singlerecord["EmailBody"],
            System: this.singlerecord["IsSystemNotification"],
            SystemNotification: this.singlerecord["NotificationText"],
            ANTYPE: this.singlerecord["ANType"],
            NotifEvent: this.singlerecord["NotificationEventID"],
            ApplicationType : this.MappedApplications
        });

        if (this.singlerecord["NotificationEventID"]) {
            this.AlertsAndNotificationsModal.controls["NotifEvent"].setValue(
                this.singlerecord["NotificationEventID"]
            );
        } else {
            this.AlertsAndNotificationsModal.controls["NotifEvent"].setValue(
                ""
            );
        }

        if (this.singlerecord["AlertEventID"]) {
            this.AlertsAndNotificationsModal.controls["AlertEvent"].setValue(
                this.singlerecord["AlertEventID"]
            );
            if (this.singlerecord["EventDays"] != null)
                this.AlertsAndNotificationsModal.get("DaysNo")?.enable();
        } else {
            this.AlertsAndNotificationsModal.controls["AlertEvent"].setValue(
                ""
            );
            this.AlertsAndNotificationsModal.get("DaysNo")?.disable();
        }

        this.selectedtoplaceholders =
            this.singlerecord["ToPlaceHoldersString"] == null
                ? null
                : this.singlerecord["ToPlaceHoldersString"].split(",");
        this.selectedccplaceholders =
            this.singlerecord["CcPlaceHoldersString"] == null
                ? null
                : this.singlerecord["CcPlaceHoldersString"].split(",");
        this.selectedsystemtoplaceholders =
            this.singlerecord["NotificationToPlaceHoldersString"] == null
                ? null
                : this.singlerecord["NotificationToPlaceHoldersString"].split(",");
        this.AlertsAndNotificationsModal.controls[
            "EmailToPlaceHolders"
        ].setValue(this.selectedtoplaceholders);
        this.AlertsAndNotificationsModal.controls[
            "EmailCCPlaceHolders"
        ].setValue(this.selectedccplaceholders);
        this.AlertsAndNotificationsModal.controls[
            "SystemToPlaceHolders"
        ].setValue(this.selectedsystemtoplaceholders);

        if (this.AlertsAndNotificationsModal.get("Email")?.value) {
            this.enableemailcontrols();
        }

        if (this.AlertsAndNotificationsModal.get("System")?.value) {
            this.enablesystemcontrols();
        }

        if(this.Heading == 'View'){
            this.AlertsAndNotificationsModal.disable();
            this.AddDisable = true;
            this.disableNotifinfo = true;
            this.disableinfo = true;
            setTimeout(() => {
                this.AlertsAndNotificationsModal.controls["EmailBody"]?.disable();
            }, 400);
        }

        if(this.Heading == 'Edit'){
            if((this.singlerecord["NotificationEventID"] == this.NotificationEvents[0]?.PK_ALERTNOTIF_TYPE_ID)
                && this.singlerecord["NotificationEventID"] != undefined
                && this.singlerecord["NotificationEventID"] != null){
                this.AlertsAndNotificationsModal.controls["System"]?.disable();
                this.AlertsAndNotificationsModal.controls["System"].setValue(false);
                this.AlertsAndNotificationsModal.controls["SystemToPlaceHolders"]?.disable();
            }

            if((this.singlerecord["NotificationEventID"] == this.NotificationEvents[1]?.PK_ALERTNOTIF_TYPE_ID)
                && this.singlerecord["NotificationEventID"] != undefined
                && this.singlerecord["NotificationEventID"] != null){
                this.AlertsAndNotificationsModal.get("Email")?.disable();
                this.AlertsAndNotificationsModal.controls["Email"].setValue(false);
                setTimeout(() => {
                    this.AlertsAndNotificationsModal.controls["EmailBody"]?.disable();
                }, 400);
            }

        }
  }

}
